import React from "react";
import {
  mdiEmailCheckOutline,
  mdiLightningBolt,
  mdiFileDocumentEditOutline,
} from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";

const ROWS = [
  {
    icon: mdiEmailCheckOutline,
    title: "Secure Email Connection",
    body: "Connect to send automated emails from your address. Morph will not read or access your private inbox.",
  },
  {
    icon: mdiLightningBolt,
    title: "Automated Workflow",
    body: "Emails like booking confirmations and reminders are sent automatically as each job progresses.",
  },
  {
    icon: mdiFileDocumentEditOutline,
    title: "Customize",
    body: "Personalize your email subjects and messages to match your brand and communication style.",
  },
];

const EmailHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How Email Automation Works"
    rows={ROWS}
  />
);

export default EmailHowItWorksModal;
